import React from 'react';
import { RedFlagIcon } from '../RedFlagIcon';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import PriceFont from '@jbhi-fi/lanyard-ui/font/PriceFont';
import { styles } from './RedFlag.css';

export type RedFlagProps = {
  variant: 'small' | 'large' | 'mobile';
  endDate?: string;
  pricePercentNumber?: string;
  hasPriceOrPercent: boolean;
  isHalfPrice: boolean;
  isWhileStocksLast: boolean;
  isMoreThanHalfPrice: boolean;
  shouldShowPriceBadge: boolean;
  isLongPrice: boolean;
  subText?: string;
  hotDealHalfPriceText?: string;
};
export const RedFlag = ({
  variant,
  endDate,
  pricePercentNumber,
  hasPriceOrPercent,
  isHalfPrice,
  isWhileStocksLast,
  isMoreThanHalfPrice,
  shouldShowPriceBadge,
  isLongPrice,
  subText,
  hotDealHalfPriceText,
}: RedFlagProps) => {
  const isMobile = variant === 'mobile';
  const isSmall = variant === 'small';
  const isLarge = variant === 'large';
  const dropShadow = isLarge ? 'drop-shadow(3px 3px 0px black)' : 'drop-shadow(2px 2px 0px black)';

  return (
    <>
      {(hasPriceOrPercent && pricePercentNumber === undefined) || (isHalfPrice && !isMoreThanHalfPrice) ? null : (
        <>
          <div
            className={styles.container({
              isMobile,
              isSmall,
              isLarge,
            })}
          >
            <RedFlagIcon className={styles.background} style={{ filter: dropShadow }} />

            <div className={styles.content}>
              {shouldShowPriceBadge ? (
                <>
                  <PriceFont
                    className={
                      isLongPrice
                        ? styles.longPrice({
                            isMobile,
                            isSmall,
                            isLarge,
                          })
                        : styles.price({
                            isMobile,
                            isSmall,
                            isLarge,
                          })
                    }
                  >
                    {pricePercentNumber}
                  </PriceFont>
                  <CalloutFont
                    className={styles.subText({
                      isMobile,
                      isSmall,
                      isLarge,
                    })}
                  >
                    {subText}
                  </CalloutFont>
                </>
              ) : isWhileStocksLast ? (
                <CalloutFont
                  className={styles.whileStocksLast({
                    isMobile,
                    isSmall,
                    isLarge,
                  })}
                >
                  WHILE STOCKS LAST!
                </CalloutFont>
              ) : !hasPriceOrPercent ? (
                <CalloutFont
                  className={styles.hotDealHalfPrice({
                    isMobile,
                    isSmall,
                    isLarge,
                  })}
                >
                  {hotDealHalfPriceText}
                </CalloutFont>
              ) : null}
            </div>
          </div>
          <div>
            {endDate && (isLarge || isMobile) ? (
              <div
                className={styles.endDateContainer({
                  isMobile,
                  isSmall,
                  isLarge,
                })}
              >
                <CalloutFont
                  className={styles.endDateText({
                    isMobile,
                    isSmall,
                    isLarge,
                  })}
                >
                  Ends {endDate}
                </CalloutFont>
              </div>
            ) : null}
          </div>
        </>
      )}
    </>
  );
};
